<!-- DetailBottomPage -->
<template>
  <div>
    <div class="recommend">
      <div class="recommend-top">
        <span class="recommend-top-title">{{ $t('home_recommend') }}</span>
        <span class="recommend-right-more"
              @click="gotoDiscover">{{$t('home_more')}}</span>
        <img class="recommend-right-arrow"
             src="@/assets/home/arrow.png"
             @click="gotoDiscover"
             alt="" />
      </div>
      <div class="recommend-container">
        <div class="recommend-container-item"
             v-for="(item, index) in newRelatedList"
             :key="index"
             @click="gotoDetail(item)">
          <a :href="'https://www.interlib.asia/' + (languageType == 'en' ? 'en/' : 'cn/') + item.id + '-' + item.projectNameEn.replace(/\s+/g, '-')"></a>
          <img :src="item.imageUrl"
               alt="" />
          <div class="recommend-container-top-detail">
            <span class="movies-title">{{  languageType == 'en' ? item.projectNameEn : item.projectName }}</span>
            <span class="movies-detail">{{ item.genres.map(genre => genre.name).join(',') }}</span>
            <span class="movies-time">{{ item.episode + 'eps' + ' x ' + item.length + 'mins' }}</span>
            <div class="movies-collect">
              <div class="movies-collect-pic">❤</div>
              <div class="movies-collect-count">
                {{ item.collectionCountContent }}
              </div>
            </div>
          </div>
          <div class="top-collect">
            <img :src="item.collectionFlag == 1 ? require('@/assets/home/collect-select.jpg') : require('@/assets/home/collect-normal.jpg') "
                 alt=""
                 @click="topCollectClick(item, $event)">
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-logo">
        <img src="@/assets/home/interlib-logo.png"
             alt="" />
      </div>
      <div class="footer-title">{{ $t('footer_title') }}</div>
      <div class="footer-detail">
        {{ $t('footer_detail') }}
      </div>
      <div class="footer-third-contact">
        <img src="@/assets/home/email.png"
             class="footer-third-contact-img"
             @click="gotoEmail"
             alt="" />
        <img src="@/assets/home/instagram.png"
             class="footer-third-contact-img"
             @click="gotoInsgram"
             alt="" />
        <img src="@/assets/home/twitter.png"
             class="footer-third-contact-twitter"
             @click="gotoTwitter"
             alt="" />
        <img src="@/assets/home/facebook.png"
             class="footer-third-contact-img"
             @click="gotoFacebook"
             alt="" />
      </div>

      <div class="footer-address">
        <div class="footer-address-info">
          {{ $t('footer_address_info') }}
        </div>
        <div class="footer-address-contact"
             @click="contactUsClick">{{ $t('contact_us') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('collectDialog', ['projectId']),
    ...mapState('auth', ['isLoggedIn'])
  },
  props: {
    detailData: {},
    relateList: {
      type: [],
      required: true
    },
  },
  created () {
    // 创建一个 MediaQueryList 对象，传入媒体查询条件
    var mediaQuery = window.matchMedia('(max-width: 1024px)');
    // 检查是否匹配指定的媒体查询条件
    if (mediaQuery.matches) {
      // 在此处执行适应小屏幕的代码
      console.log('屏幕宽度小于等于 1024px');
      this.isMobile = true;
    } else {
      // 在此处执行适应大屏幕的代码
      console.log('屏幕宽度大于 1024px');
      this.isMobile = false;
    }
    this.reloadLocationLanguageData()

    this.$store.watch(
      (state) => state.collectDialog.hasCollectSuccess,
      (newVal) => {
        // 处理hasCollectSuccess的变化
        if (newVal) {
          if (this.selectItem.collectionFlag == 0) {
            if (this.collectType == 0 && this.selectItem.id == this.projectId) {
              console.log('DetailPageTrailersCast-Banner-hasCollectSuccess:', newVal);

              this.dataList = this.dataList.map(item => {
                if (item.id === this.selectItem.id) {
                  console.log('Banner-匹配数据:', item.id === this.selectItem.id);
                  item.collectionFlag = 1;
                }
                return item;
              });
              this.setCollectNormalDialog()

            } else if (this.collectType == 1 && this.selectItem.id == this.projectId) {
              console.log('DetailPageTrailersCast-Recommend-hasCollectSuccess:', newVal);

              this.newRelatedList = this.newRelatedList.map(item => {
                if (item.id === this.selectItem.id) {
                  console.log('Recommend-匹配数据:', item.id === this.selectItem.id);
                  item.collectionFlag = 1;
                }
                return item;
              });
              this.setCollectNormalDialog()

            }
          }
        }
      }
    );
  },
  // director 组件的 watch 配置
  watch: {
    relateList (newVal) {
      if (newVal && newVal.length > 0) {
        this.newRelatedList = newVal
        if (this.isMobile) {
          if (this.newRelatedList && this.newRelatedList.length > 5) {
            this.newRelatedList = this.newRelatedList.slice(0, 5);
          }
        }
      } else {
        console.log('relateList is empty or undefined');
      }
    }

  },

  data () {
    return {
      selectedDirectorIndex: 0,
      newMenuList: [],
      directorInfo: {},
      influenceList: [],
      scrollPosition: 0,
      maxScroll: 0,
      bannerMenuList: [],
      bannerCurrentIndex: 0, //banner菜单栏
      dataList: [],
      masterpieceBannerList: [],

      upcomingBannerList: [],

      selectItem: {},
      collectType: 0, //0:BannerCollect 1:RecommendCollect
      newRelatedList: [],
      languageType: "",
      isMobile: false,
    }
  },
  methods: {
    ...mapActions('collectDialog', ['showCollectOfWorksDialog', 'setProjectIdDialog', 'hasCollectSuccess', 'setCollectNormalDialog']),
    ...mapActions('deatilEra', ['setDeatilEra']),
    ...mapActions('dialog', ['showLoginDialog']),

    reloadLocationLanguageData () {
      // 检查本地存储中的语言类型
      const language = localStorage.getItem('locationLanguageType')

      if (language == 'zh') {
        this.languageType = 'zh'
        this.$i18n.locale = 'zh';
      } else {
        localStorage.setItem('locationLanguageType', 'en')
        this.languageType = 'en'
        this.$i18n.locale = 'en';
      }
    },

    slideLeft () {
      console.log('slideLeft');
      const container = document.querySelector('.popular-container');
      const itemWidth = container.offsetWidth;
      const scrollAmount = itemWidth;

      container.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    },

    slideRight () {
      console.log('slideRight');
      const container = document.querySelector('.popular-container');
      const itemWidth = container.offsetWidth;
      const scrollAmount = itemWidth;

      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    },

    resetData () {
      this.selectedDirectorIndex = 0
      this.newMenuList = []
      this.directorInfo = {}
      this.influenceList = []
      this.scrollPosition = 0
      this.maxScroll = 0
      this.bannerMenuList = []
      this.bannerCurrentIndex = 0
      this.dataList = []
      this.masterpieceBannerList = []

      this.upcomingBannerList = []

      this.selectItem = {}
      this.collectType = 0
    },
    gotoDiscover () {
      const genresIds = this.detailData.genres.map(item => item.id);
      localStorage.setItem('detailType', this.detailData.type ? this.detailData.type : '');
      localStorage.setItem('detailGenres', genresIds ? genresIds[0] : '');
      localStorage.setItem('detailEra', this.detailData.era ? this.detailData.era : '');

      console.log("detailType:", localStorage.getItem('detailType'));
      console.log("detailGenres:", localStorage.getItem('detailGenres'));
      console.log("detailEra:", localStorage.getItem('detailEra'));

      this.$router.push({ name: 'language-discover', params: { language: this.languageType === 'zh' ? 'cn' : 'en' } })
    },
    gotoDetail (item) {
      if (this.detailData.id === item.id) {
        this.$emit('clickAndScrollToTop');
        return;
      }
      // 在详情页中再次导航到另一个详情页
      const targetPath = item.id + '-' + item.projectNameEn.trim().replace(/\s+/g, "-");
      if (this.$route.path !== targetPath) {
        console.log("gotoDetail-era:", item.era);
        this.setDeatilEra(item.era)
        this.$router.push(targetPath);
      }
    },

    topCollectClick (item, event) {
      // 阻止事件冒泡到父元素的点击事件
      event.stopPropagation();
      if (this.isLoggedIn) {
        this.selectItem = item
        this.collectType = 1

        console.log("topCollectClick:", item.id);
        this.showCollectOfWorksDialog()
        this.setProjectIdDialog(item.id)
        console.log("projectId:", this.projectId);
      } else {
        this.showLoginDialog()
      }

    },
    //Contact Us
    contactUsClick () {
      this.$nextTick(() => {
        this.$router.push({ name: 'language-contact-us', params: { language: this.languageType === 'zh' ? 'cn' : 'en' } })
      })
    },

    scrollRight () {
      this.scrollPosition += this.$refs.scrollContainer.clientWidth;
      this.$refs.scrollContainer.scrollTo({ left: this.scrollPosition, behavior: 'smooth' });
    },
    scrollLeft () {
      this.scrollPosition -= this.$refs.scrollContainer.clientWidth;
      this.$refs.scrollContainer.scrollTo({ left: this.scrollPosition, behavior: 'smooth' });

    },
    handleScroll () {
      this.scrollPosition = this.$refs.scrollContainer.scrollLeft + 61;

      if (this.scrollPosition <= 61) {
        // 滑动到列表最左侧，隐藏左侧按钮
        this.scrollPosition = 0
      }

      if (this.scrollPosition >= this.maxScroll) {
        // 滑动到列表最右侧，隐藏右侧按钮
        this.scrollPosition = this.maxScroll
      }
    },
    gotoEmail () {
      const email = 'info@interlib.asia';
      const subject = '';
      const body = '';
      const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.open(mailtoLink);
    },
    gotoInsgram () {
      window.open('https://www.instagram.com/interlib_asia/', "_blank");
    },
    gotoTwitter () {
      window.open('https://twitter.com/AInterlib95465', "_blank");
    },
    gotoFacebook () {
      window.open('https://www.facebook.com/profile.php?id=61551731825749', "_blank");
    }
  },
}
</script>

<style scoped>
.movies-title {
  color: #fff;
  font-size: 16px;
  font-family: Source Han Sans SC-Bold;
}

.movies-detail {
  color: #a6a6a6;
  font-size: 12px;
  font-family: Source Han Sans SC-Normal;
}

.movies-time {
  color: #fff;
  font-size: 12px;
  font-family: Source Han Sans SC-Normal;
}

.movies-collect {
  color: #fff;
  font-size: 12px;
  font-family: Source Han Sans SC-Normal;
}

.top-collect {
  position: absolute;
  top: 0;
  right: 0;

  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 15px 15px;
  z-index: 100;
}

/* Recommend---start */
.recommend {
  margin-top: 0px;
  margin-left: 0px;
  margin-right: -20px;
}

.recommend-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-right: 15px;
  margin-bottom: 20px;
}

.recommend-top-title {
  margin-top: 10px;
  color: #fff;
  font-size: 22px;
  font-family: Source Han Sans SC-Medium;
}

.recommend-right-more {
  position: absolute;
  right: 0;
  margin-right: 20px;
  color: #fff;
  font-size: 16px;
  font-family: Source Han Sans SC-Normal;
  margin-bottom: 5px;
  cursor: pointer;
}

.recommend-right-arrow {
  width: 7px;
  height: auto;
  position: absolute;
  right: 0;
  cursor: pointer;
  margin-right: 5px;
}

.recommend-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 0px;
  margin-right: 0px;
  flex-grow: 1;
}

.recommend-container-item {
  width: calc(100% / 6 - 20px);
  margin-right: 20px;
  margin-bottom: 40px;
  box-sizing: border-box;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 10px 13px 18px rgba(0, 0, 0, 0.3);
  transition: transform 0.5s ease;
}

.recommend-container-item::after {
  display: block;
  content: "";
  padding-top: calc(100% * (302 / 229));
}

.recommend-container-item:hover {
  transform: translateY(-5px);
}

.recommend-container-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.recommend-container-item:hover::before {
  opacity: 1;
}

.recommend-container-item:hover .recommend-container-top-detail span {
  animation: moveUp 0.5s ease forwards;
}

.recommend-container-item:hover
  .recommend-container-top-detail
  .movies-collect-pic {
  animation: moveUp 0.5s ease forwards;
}
.recommend-container-item:hover
  .recommend-container-top-detail
  .movies-collect-count {
  animation: moveUp 0.5s ease forwards;
}

@keyframes moveUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-5px);
  }
}

.recommend-container-item img {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  border: none;
  object-fit: cover;
}

.recommend-container-top-detail {
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 1),
    rgba(0, 0, 0, 0.9),
    rgba(0, 0, 0, 0.8),
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0.1),
    rgba(0, 0, 0, 0)
  ); /* 渐变背景 */
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  height: 80%;
}

.top-collect {
  position: absolute;
  top: 0;
  right: 0;

  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 15px 15px;
  z-index: 100;
}

.recommend-container-top-detail .movies-title {
  color: #fff;
  font-size: 14px;
  font-family: Source Han Sans SC-Medium;
  line-height: 1.1;
  margin-left: 10px;
  margin-right: 10px;
  white-space: pre-wrap;
}

.recommend-container-top-detail .movies-detail {
  margin-top: 4px;
  /* margin-bottom: 4px; */
  color: #a6a6a6;
  font-size: 12px;
  font-family: Source Han Sans SC-Normal;
  line-height: 1.3;
  margin-left: 10px;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
}

.recommend-container-top-detail .movies-time {
  color: #fff;
  font-size: 12px;
  font-family: Source Han Sans SC-Normal;
  margin-top: 5px;
}

.recommend-container-top-detail .movies-collect {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  font-family: Source Han Sans SC-Normal;
  margin-bottom: 20px;
}

.movies-collect-pic {
  margin-right: 4px;
  color: #eb366b;
  font-size: 12px;
  font-family: Source Han Sans SC-Normal;
}

.movies-collect-count {
  color: #fff;
  font-size: 12px;
  font-family: Source Han Sans SC-Normal;
}
/* Recommend---end */

/* Footer---start */
.footer {
  margin-left: 30px;
  margin-right: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-logo {
  margin-top: 50px;
  height: 32px;
}

.footer-logo img {
  height: 100%;
}

.footer-title {
  margin-top: 30px;
  color: #8e8e8e;
  font-size: 13px;
  font-family: Source Han Sans SC-Normal;
}

.footer-detail {
  color: #8e8e8e;
  font-size: 13px;
  font-family: Source Han Sans SC-Normal;
}

.footer-third-contact {
  margin-top: 70px;
  height: 40px;
  align-content: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.footer-third-contact-img {
  margin: auto 10px;
  width: 20px;
  cursor: pointer;
}

.footer-third-contact-twitter {
  margin: auto 10px;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.footer-address {
  margin-top: 15px;
  color: #fff;
  margin-bottom: 70px;
  font-size: 13px;
  font-family: Source Han Sans SC-Normal;
  display: flex;
  flex-direction: row;
}

.footer-address-contact {
  margin-left: 30px;
  text-decoration: underline;
  text-underline-offset: 0.5em;
  cursor: pointer;
}
/* Footer---end */

::-webkit-scrollbar {
  background-color: transparent;
}

/* 整个滚动条 */
::-webkit-scrollbar {
  width: 2px;
  border-radius: 3px;
  background-color: transparent;
  /* 隐藏水平滚动条 */
  height: 0;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: #f1f1f1;
  border-radius: 6px;
}
</style>


<style scoped>
@media only screen and (max-width: 1024px) {
  .movies-title {
    color: #fff;
    font-size: 12px;
    font-family: Source Han Sans SC-Medium;
  }

  .movies-detail {
    color: #a6a6a6;
    font-size: 0px;
    font-family: Source Han Sans SC-Normal;
  }

  .movies-time {
    color: #fff;
    font-size: 0px;
    font-family: Source Han Sans SC-Normal;
  }

  .movies-collect {
    color: #fff;
    font-size: 0px;
    font-family: Source Han Sans SC-Normal;
  }

  .top-collect {
    position: absolute;
    top: 0;
    right: 0;

    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 10px 10px;
    z-index: 100;
  }

  /* Recommend---start */
  .recommend {
    margin-top: 0px;
    margin-left: 0px;
    margin-right: -20px;
  }

  .recommend-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    margin-right: 15px;
    margin-bottom: 20px;
  }

  .recommend-top-title {
    margin-top: 10px;
    color: #fff;
    font-size: 14px;
    font-family: Source Han Sans SC-Medium;
  }

  .recommend-right-more {
    position: absolute;
    right: 0;
    margin-right: 20px;
    color: #fff;
    font-size: 12px;
    font-family: Source Han Sans SC-Normal;
    margin-bottom: 5px;
    cursor: pointer;
  }

  .recommend-right-arrow {
    width: 7px;
    height: auto;
    position: absolute;
    right: 0;
    cursor: pointer;
    margin-right: 5px;
  }

  .recommend-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: 0px;
    margin-right: 0px;
    flex-grow: 1;
  }

  .recommend-container-item {
    width: calc(100% / 5 - 15px);
    margin-right: 15px;
    margin-bottom: 15px;
    box-sizing: border-box;
    position: relative;
    border-radius: 15px;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 10px 13px 18px rgba(0, 0, 0, 0.3);
  }

  .recommend-container-item::after {
    display: block;
    content: "";
    padding-top: calc(100% * (302 / 229));
  }

  .recommend-container-item:hover {
    transform: translateY(0px);
  }

  .recommend-container-item::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .recommend-container-item:hover::before {
    opacity: 1;
  }

  .recommend-container-item:hover .recommend-container-top-detail span {
    animation: moveUp 0.5s ease forwards;
  }

  .recommend-container-item:hover
    .recommend-container-top-detail
    .movies-collect-pic {
    animation: moveUp 0.5s ease forwards;
  }
  .recommend-container-item:hover
    .recommend-container-top-detail
    .movies-collect-count {
    animation: moveUp 0.5s ease forwards;
  }

  @keyframes moveUp {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(0px);
    }
  }

  .recommend-container-item img {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    border: none;
    object-fit: cover;
  }

  .recommend-container-top-detail {
    position: absolute;
    width: 100%;
    bottom: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 1),
      rgba(0, 0, 0, 0.9),
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0)
    ); /* 渐变背景 */
    border-bottom-left-radius: 13px;
    border-bottom-right-radius: 13px;
    height: 80%;
  }

  .top-collect {
    position: absolute;
    top: 0;
    right: 0;

    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 10px 10px;
    z-index: 100;
  }

  .recommend-container-top-detail .movies-title {
    color: #fff;
    font-size: 12px;
    font-family: Source Han Sans SC-Medium;
    line-height: 1.1;
    margin-left: 10px;
    margin-right: 10px;
    white-space: pre-wrap;
  }

  .recommend-container-top-detail .movies-detail {
    margin-top: 4px;
    /* margin-bottom: 4px; */
    color: #a6a6a6;
    font-size: 12px;
    font-family: Source Han Sans SC-Normal;
    line-height: 1.3;
    margin-left: 10px;
    margin-right: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }

  .recommend-container-top-detail .movies-time {
    color: #fff;
    font-size: 0px;
    font-family: Source Han Sans SC-Normal;
    margin-top: 5px;
  }

  .recommend-container-top-detail .movies-collect {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 0px;
    font-family: Source Han Sans SC-Normal;
    margin-bottom: 10px;
  }

  .movies-collect-pic {
    margin-right: 4px;
    color: #eb366b;
    font-size: 0px;
    font-family: Source Han Sans SC-Normal;
  }

  .movies-collect-count {
    color: #fff;
    font-size: 0px;
    font-family: Source Han Sans SC-Normal;
  }
  /* Recommend---end */

  /* Footer---start */
  .footer {
    margin-left: 14px;
    margin-right: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer-logo {
    margin-top: 50px;
    height: 22px;
  }

  .footer-logo img {
    height: 100%;
  }

  .footer-title {
    margin-top: 30px;
    color: #8e8e8e;
    font-size: 12px;
    font-family: Source Han Sans SC-Normal;
  }

  .footer-detail {
    color: #8e8e8e;
    font-size: 12px;
    font-family: Source Han Sans SC-Normal;
    text-align: center;
  }

  .footer-third-contact {
    margin-top: 50px;
    height: 30px;
    align-content: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .footer-third-contact-img {
    margin: auto 10px;
    width: 16px;
    cursor: pointer;
  }

  .footer-third-contact-twitter {
    margin: auto 10px;
    width: 13px;
    height: 13px;
    cursor: pointer;
  }

  .footer-address {
    margin-top: 15px;
    color: #fff;
    margin-bottom: 50px;
    font-size: 12px;
    font-family: Source Han Sans SC-Normal;
    display: flex;
    flex-direction: row;
  }

  .footer-address-contact {
    margin-left: 30px;
    text-decoration: underline;
    text-underline-offset: 0.5em;
    cursor: pointer;
  }
  /* Footer---end */

  ::-webkit-scrollbar {
    background-color: transparent;
  }

  /* 整个滚动条 */
  ::-webkit-scrollbar {
    width: 2px;
    border-radius: 3px;
    background-color: transparent;
    /* 隐藏水平滚动条 */
    height: 0;
  }

  /* 滚动条轨道 */
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    background-color: #f1f1f1;
    border-radius: 6px;
  }
}
</style>
